// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ReactDropdown from 'react-dropdown';
import { transparentize } from 'polished';
import styled from '../../styled-components';
import { StyledDropdown } from '../../common-elements';
export const MimeLabel = styled.div.withConfig({
  displayName: "styledelements__MimeLabel",
  componentId: "pwi8hn-0"
})(["padding:0.9em;background-color:", ";margin:0 0 10px 0;display:block;font-family:", ";font-size:0.929em;line-height:1.5em;"], ({
  theme
}) => transparentize(0.6, theme.rightPanel.backgroundColor), ({
  theme
}) => theme.typography.headings.fontFamily);
export const DropdownLabel = styled.span.withConfig({
  displayName: "styledelements__DropdownLabel",
  componentId: "pwi8hn-1"
})(["font-family:", ";font-size:12px;position:absolute;z-index:1;top:-11px;left:12px;font-weight:", ";color:", ";"], ({
  theme
}) => theme.typography.headings.fontFamily, ({
  theme
}) => theme.typography.fontWeightBold, ({
  theme
}) => transparentize(0.6, theme.rightPanel.textColor));
export const DropdownWrapper = styled.div.withConfig({
  displayName: "styledelements__DropdownWrapper",
  componentId: "pwi8hn-2"
})(["position:relative;"]);
export const InvertedSimpleDropdown = styled(StyledDropdown).withConfig({
  displayName: "styledelements__InvertedSimpleDropdown",
  componentId: "pwi8hn-3"
})(["margin-left:10px;text-transform:none;font-size:1em;margin:0 0 10px 0;display:block;background-color:", ";.Dropdown-placeholder{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;}.Dropdown-control{margin-top:0;}.Dropdown-control,.Dropdown-control:hover{font-size:1em;border:none;padding:0.9em 1.6em 0.9em 0.9em;background:transparent;color:", ";box-shadow:none;.Dropdown-arrow{border-top-color:", ";}}.Dropdown-menu{margin:0;margin-top:2px;.Dropdown-option{text-overflow:ellipsis;white-space:nowrap;overflow:hidden;}}"], ({
  theme
}) => transparentize(0.6, theme.rightPanel.backgroundColor), ({
  theme
}) => theme.rightPanel.textColor, ({
  theme
}) => theme.rightPanel.textColor);
export const NoSampleLabel = styled.div.withConfig({
  displayName: "styledelements__NoSampleLabel",
  componentId: "pwi8hn-4"
})(["font-family:", ";font-size:12px;color:#ee807f;"], props => props.theme.typography.code.fontFamily);